// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M1.5 3.8H8.75M4.75 1.5H5.25',
  'M7.5 3.8C7 6.25 5 8.7 2.2 10',
  'M3.05 5.65C3.85 7.15 5.4 8.65 7.25 9.7',
  'M8.5 14.5L11.04 7.95C11.2 7.55 11.8 7.55 11.96 7.95L14.5 14.5M9.47 12H13.53',
];
